<template>
  <a-breadcrumb style="margin: 16px 0">
    <a-breadcrumb-item>SIG&Committer</a-breadcrumb-item>
    <a-breadcrumb-item>SIG PR 分析</a-breadcrumb-item>
  </a-breadcrumb>

  <div style="display: flex; justify-content: flex-end; margin-bottom: 20px;">
    <span class="caption-and-select-container">
      <span class="caption">组织</span>
      <a-select v-model:value="upperSelected.organization" class="select">
        <a-select-option v-for="opt in upperOptions.organization" :key="opt.key" :value="opt.value">
          {{ opt.label }}
        </a-select-option>
      </a-select>
    </span>
    <span class="caption-and-select-container">
      <span class="caption">时间</span>
      <a-select v-model:value="upperSelected.time" class="select">
        <a-select-option v-for="opt in upperOptions.time" :key="opt.key" :value="opt.value">
          {{ opt.label }}
        </a-select-option>
      </a-select>
    </span>
  </div>

  <a-spin :spinning="prDesignBoardLoading">
    <div class="stat-cards">
      <div v-for="card in statCards.slice(0, 4)" :key="card.key" class="stat-card">
        <div class="stat-card-icon"
          :style="{ color: card.key === 'created' ? '#2B7FFF' : card.key === 'merged' ? '#00C950' : card.key === 'open' ? '#FF6900' : '#FB2C36' }">
          <component :is="card.icon" />
        </div>
        <div v-if="upperSelected.time !== 0"
          :class="['stat-card-badge', card.rate >= 0 ? 'stat-rate-up' : 'stat-rate-down']">
          {{ card.rate >= 0 ? '+' : '' }}{{ Number(card.rate).toFixed(1) }}%
        </div>
        <div class="stat-card-title">{{ card.title }}</div>
        <div class="stat-card-value">{{ formatStatValue(card.value, card.key) }}</div>
        <div class="stat-card-sub">{{ card.sub }}</div>
      </div>
    </div>
    <div class="stat-cards">
      <div v-for="card in statCards.slice(4)" :key="card.key" class="stat-card">
        <div class="stat-card-icon" :style="{ color: card.key === 'averClosedRate' ? '#00C950' : '#2B7FFF' }">
          <component :is="card.icon" />
        </div>
        <div class="stat-card-title">{{ card.title }}</div>
        <div class="stat-card-value">
          {{ formatStatValue(card.value, card.key) }}
          <span v-if="card.unit" class="stat-card-unit">{{ card.unit }}</span>
        </div>
        <div class="stat-card-sub">{{ card.sub }}</div>
      </div>
    </div>
  </a-spin>

  <div class="stat-cards">
    <div class="rank-card">
      <div class="rank-card-title">
        <div class="rank-card-icon" style="color: #9810fa;">
          <star-outlined />
        </div>
        TOP 活跃仓库
      </div>
      <a-spin :spinning="topReposLoading">
        <div v-for="(repo, index) in topRepos" :key="repo.repoName" class="rank-item">
          <div class="rank" :style="{ backgroundColor: getRankColor(index + 1) }">
            {{ index + 1 }}
          </div>
          <div class="ranker">
            <div class="ranker-main">{{ repo.project }}/{{ repo.repoName }}</div>
            <div class="ranker-sub">SIG：{{ repo.sigName }}</div>
          </div>
          <div class="ranker-stats">
            <div class="ranker-stats-main">{{ repo.createdPrCount }}</div>
            <div class="ranker-stats-sub">PRs</div>
          </div>
        </div>
      </a-spin>
    </div>
    <div class="rank-card">
      <div class="rank-card-title">
        <div class="rank-card-icon" style="color: #00a63e;">
          <trophy-outlined />
        </div>
        TOP 活跃 SIG
      </div>
      <a-spin :spinning="topSigsLoading">
        <div v-for="(sig, index) in topSigs" :key="sig.sigName" class="rank-item">
          <div class="rank" :style="{ backgroundColor: getRankColor(index + 1) }">
            {{ index + 1 }}
          </div>
          <div class="ranker">
            <div class="ranker-main">{{ sig.sigName }}</div>
            <div class="ranker-sub">活跃仓库：{{ sig.mergedPrCount }}/{{ sig.createdPrCount }}</div>
          </div>
          <div class="ranker-stats">
            <div class="ranker-stats-main">{{ sig.mergedPrCount }}</div>
            <div class="ranker-stats-sub">PRs</div>
          </div>
        </div>
      </a-spin>
    </div>
    <div class="rank-card">
      <div class="rank-card-title">
        <div class="rank-card-icon" style="color: #f54900;">
          <thunderbolt-outlined />
        </div>
        TOP 合并速度最快 SIG
      </div>
      <a-spin :spinning="topSpeedSigsLoading">
        <div v-for="(sig, index) in topSpeedSigs" :key="sig.sigName" class="rank-item">
          <div class="rank" :style="{ backgroundColor: getRankColor(index + 1) }">
            {{ index + 1 }}
          </div>
          <div class="ranker">
            <div class="ranker-main">{{ sig.sigName }}</div>
            <div class="ranker-sub">PR 数量：{{ sig.mergedPrCount }}</div>
          </div>
          <div class="ranker-stats">
            <div class="ranker-stats-main">{{ formatNumber(sig.mergedPrSpeed, 1) }}</div>
            <div class="ranker-stats-sub">天</div>
          </div>
        </div>
      </a-spin>
    </div>
  </div>

  <a-spin :spinning="loading">
    <div class="container">
      <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
        <span class="table-title">SIG PR 详细统计</span>
        <div style="text-align: left;">
          <span class="caption-and-select-container">
            <span class="caption">组织</span>
            <a-select v-model:value="lowerSelected.organization" class="select">
              <a-select-option v-for="opt in lowerOptions.organization" :key="opt.key" :value="opt.value">
                {{ opt.label }}
              </a-select-option>
            </a-select>
          </span>
          <span class="caption-and-select-container">
            <span class="caption">时间</span>
            <a-select v-model:value="lowerSelected.year" class="select">
              <a-select-option v-for="opt in lowerOptions.year" :key="opt.key" :value="opt.value">
                {{ opt.label }}
              </a-select-option>
            </a-select>
          </span>
        </div>
      </div>

      <a-table :columns="tableColumns" :data-source="filteredTableData" :pagination="{
        showTotal: (total, range) => `第 ${range[0]}—${range[1]} 条，共 ${total} 条`,
        showSizeChanger: true,
        defaultPageSize: 10
      }" :rowKey="record => record.key" :scroll="{ x: 980 }" />
    </div>
  </a-spin>
</template>
<script setup>
import { computed, h, ref, resolveComponent, watch } from 'vue';
import axios from 'axios';
import { notification } from 'ant-design-vue';
import {
  InfoCircleOutlined,
  BarChartOutlined,
  CheckCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  PercentageOutlined,
  StarOutlined,
  TrophyOutlined,
  ThunderboltOutlined
} from '@ant-design/icons-vue';

const upperOptions = {
  organization: [
    { key: 'all', label: '全部', value: null },
    { key: 'HUAWEI', label: '华为', value: 'HUAWEI' },
    { key: 'NON_HUAWEI', label: '非华为', value: 'NON_HUAWEI' }
  ],
  time: [
    { key: 'all', label: '全部', value: 0 },
    { key: '1m', label: '近1个月', value: 1 },
    { key: '6m', label: '近6个月', value: 6 },
    { key: '12m', label: '近12个月', value: 12 }
  ]
};
const years = [2020, 2021, 2022, 2023, 2024, 2025];
const lowerOptions = {
  organization: [
    { key: 'all', label: '全部', value: null },
    { key: 'HUAWEI', label: '华为', value: 'HUAWEI' },
    { key: 'NON_HUAWEI', label: '非华为', value: 'NON_HUAWEI' }
  ],
  year: [
    { key: 'all', label: '全部', value: null },
    ...years.map((y) => ({ key: y, label: String(y), value: y }))
  ]
};

const upperSelected = ref({ organization: null, time: 0 });
const lowerSelected = ref({ organization: null, year: null });

const loading = ref(false);
const sigFilter = ref(null);
const topRepos = ref([]);
const topSigs = ref([]);
const topSpeedSigs = ref([]);
const prDesignBoard = ref({
  created: { count: null, rate: null },
  merged: { count: null, rate: null },
  open: { count: null, rate: null },
  closed: { count: null, rate: null },
  averOpenDay: null,
  averClosedDay: null,
  averClosedRate: 0
});
const tableData = ref([]);
const topReposLoading = ref(false);
const topSigsLoading = ref(false);
const topSpeedSigsLoading = ref(false);
const prDesignBoardLoading = ref(false);

const ATooltip = resolveComponent('a-tooltip');
const AInput = resolveComponent('a-input');

const renderTitleWithTip = (label, tip) => h(
  'span',
  { style: { display: 'inline-flex', alignItems: 'center' } },
  [
    label,
    h(
      ATooltip,
      { placement: 'right' },
      {
        title: () => h('span', tip),
        default: () => h(InfoCircleOutlined, { style: 'margin-left: 5px; color: #9ca3af;' })
      }
    )
  ]
);

const renderSigHeader = () => h(
  'div',
  { style: 'display: flex; align-items: center; justify-content: space-between; gap: 8px;' },
  [
    h('span', 'SIG 名称'),
    h(AInput, {
      value: sigFilter.value,
      allowClear: true,
      placeholder: '搜索 SIG',
      'onUpdate:value': (value) => {
        sigFilter.value = value || null;
      },
      style: 'width: 160px;'
    })
  ]
);

const tableColumns = computed(() => [
  {
    title: renderSigHeader,
    dataIndex: 'sigName',
    key: 'sigName',
    width: 260
  },
  {
    title: '仓库数量',
    dataIndex: 'repoCount',
    key: 'repoCount',
    width: 120
  },
  {
    title: renderTitleWithTip(
      '活跃仓数量',
      '指在固定周期范围内至少有一次代码提交的代码仓库，用于衡量仓库的持续开发参与度。'
    ),
    dataIndex: 'activeRepoCount',
    key: 'activeRepoCount',
    width: 140
  },
  {
    title: renderTitleWithTip(
      '平均开启时长（天）',
      '全部 PR 处理的平均时长，包括已处理 PR 的耗时时长，和未处理 PR 的滞留时长。'
    ),
    dataIndex: 'avgOpenDays',
    key: 'avgOpenDays',
    width: 170,
    showSorterTooltip: false,
    sorter: (a, b) => a.avgOpenDays - b.avgOpenDays,
    customRender: ({ text }) => formatNumber(text, 1)
  },
  {
    title: renderTitleWithTip(
      '平均关闭时长（天）',
      '指处于“合并”状态和“关闭”状态的 Pull Request 从创建到处理完成的平均时长，反映 PR 的完成情况。'
    ),
    dataIndex: 'avgCloseDays',
    key: 'avgCloseDays',
    width: 170,
    showSorterTooltip: false,
    sorter: (a, b) => a.avgCloseDays - b.avgCloseDays,
    customRender: ({ text }) => formatNumber(text, 1)
  },
  {
    title: renderTitleWithTip(
      '平均关闭率',
      '（已合并PR数 + 已关闭PR数）/ 总PR数 × 100%'
    ),
    dataIndex: 'avgCloseRate',
    key: 'avgCloseRate',
    width: 120,
    showSorterTooltip: false,
    sorter: (a, b) => a.avgCloseRate - b.avgCloseRate,
    customRender: ({ text }) => `${(Number(text) * 100).toFixed(1)}%`
  }
]);

const filteredTableData = computed(() => {
  if (!sigFilter.value) return tableData.value;
  return tableData.value.filter((row) => String(row.sigName)
    .toLowerCase()
    .includes(String(sigFilter.value).toLowerCase()));
});

const formatNumber = (value, digits = 1) => {
  const num = Number(value);
  if (Number.isNaN(num)) return '-';
  return num.toFixed(digits);
};

const formatThousands = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return '-';
  return num.toLocaleString('en-US');
};

const updateFromResponse = (data) => {
  const resultList = data?.resultList || [];
  tableData.value = resultList.map((item, index) => ({
    key: item.sigName || `sig-${index}`,
    sigName: item.sigName,
    repoCount: item.allRepoNum,
    activeRepoCount: item.activeRepoNum,
    avgOpenDays: item.averOpenDay,
    avgCloseDays: item.averClosedDay,
    avgCloseRate: item.averClosedRate
  }));
};

const getRankColor = (rank) => {
  switch (rank) {
    case 1:
      return '#FDC700';
    case 2:
      return '#99A1AF';
    case 3:
      return '#FF8904';
    case 4:
      return '#C27AFF';
    case 5:
      return '#05DF72';
    default:
      return '#50A2FF';
  }
};

const statCards = computed(() => [
  {
    key: 'created',
    icon: BarChartOutlined,
    title: '总 PR 数',
    value: prDesignBoard.value.created.count,
    rate: prDesignBoard.value.created.rate,
    sub: '统计周期内，仓库提交的 PR 总数量'
  },
  {
    key: 'merged',
    icon: CheckCircleOutlined,
    title: '已合并',
    value: prDesignBoard.value.merged.count,
    rate: prDesignBoard.value.merged.rate,
    sub: '统计周期内，已成功合并到主分支的 PR 数量'
  },
  {
    key: 'open',
    icon: ClockCircleOutlined,
    title: '进行中',
    value: prDesignBoard.value.open.count,
    rate: prDesignBoard.value.open.rate,
    sub: '统计周期内，处于开启状态正在处理中的 PR 数量'
  },
  {
    key: 'closed',
    icon: StopOutlined,
    title: '已关闭',
    value: prDesignBoard.value.closed.count,
    rate: prDesignBoard.value.closed.rate,
    sub: '统计周期内关闭而未合并的 PR 数量'
  },
  {
    key: 'averOpenDay',
    icon: ClockCircleOutlined,
    title: '平均开启时长',
    value: prDesignBoard.value.averOpenDay,
    rate: null,
    unit: '天',
    sub: '全部 PR 处理的平均时长，包括已处理 PR 的耗时时长，和未处理 PR 的滞留时长'
  },
  {
    key: 'averClosedDay',
    icon: ClockCircleOutlined,
    title: '平均关闭时长',
    value: prDesignBoard.value.averClosedDay,
    rate: null,
    unit: '天',
    sub: '指处于“合并”状态和“关闭”状态的 Pull Request 从创建到处理完成的平均时长，反映 PR 的完成情况'
  },
  {
    key: 'averClosedRate',
    icon: PercentageOutlined,
    title: '平均关闭率',
    value: prDesignBoard.value.averClosedRate,
    rate: null,
    unit: '%',
    sub: '（已合并PR数 + 已关闭PR数）/ 总PR数 × 100%'
  }
]);

const formatStatValue = (value, key) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '-';
  if (['averClosedRate', 'averOpenDay', 'averClosedDay'].includes(key)) return Number(value).toFixed(1);
  if (['created', 'merged', 'open', 'closed'].includes(key)) return formatThousands(value);
  return value;
};

const fetchTopRankLists = async () => {
  const params = {
    sigType: upperSelected.value.organization,
    time: upperSelected.value.time
  };

  topReposLoading.value = true;
  topSigsLoading.value = true;
  topSpeedSigsLoading.value = true;
  prDesignBoardLoading.value = true;

  try {
    const [boardRes, reposRes, sigsRes, speedsRes] = await Promise.all([
      axios.get('/metric/prDesignBoard', { params }),
      axios.get('/metric/pr/topRepos', { params }),
      axios.get('/metric/pr/topSigs', { params }),
      axios.get('/metric/pr/topSpeedSigs', { params }),
    ]);
    if (boardRes.data?.code === 200) {
      prDesignBoard.value = boardRes.data?.data;
    } else {
      notification.error({ message: '请求 PR 设计看板数据失败', description: boardRes.data?.msg });
    }
    if (reposRes.data?.code === 200) {
      topRepos.value = reposRes.data?.data;
    } else {
      notification.error({ message: '请求 TOP 活跃仓库失败', description: reposRes.data?.msg });
    }
    if (sigsRes.data?.code === 200) {
      topSigs.value = sigsRes.data?.data;
    } else {
      notification.error({ message: '请求 TOP 活跃 SIG 失败', description: sigsRes.data?.msg });
    }
    if (speedsRes.data?.code === 200) {
      topSpeedSigs.value = speedsRes.data?.data;
    } else {
      notification.error({ message: '请求 TOP 合并速度最快 SIG 失败', description: speedsRes.data?.msg });
    }
  } catch (error) {
    notification.error({
      message: '排行榜数据加载失败',
      description: error?.message || error
    });
  } finally {
    topReposLoading.value = false;
    topSigsLoading.value = false;
    topSpeedSigsLoading.value = false;
    prDesignBoardLoading.value = false;
  }
};

const fetchSigPrData = async () => {
  loading.value = true;
  try {
    const res = await axios.get('/metric/sigPr', {
      params: {
        year: lowerSelected.value.year,
        sigType: lowerSelected.value.organization
      }
    });
    if (res.data?.code !== 200) {
      throw new Error(res.data?.desc || '请求失败');
    }
    updateFromResponse(res.data?.data || {});
  } catch (error) {
    notification.error({
      message: '数据加载失败',
      description: error?.message || error
    });
  } finally {
    loading.value = false;
  }
};

watch([() => lowerSelected.value.year, () => lowerSelected.value.organization], () => {
  fetchSigPrData();
}, { immediate: true });

watch([() => upperSelected.value.organization, () => upperSelected.value.time], () => {
  fetchTopRankLists();
}, { immediate: true });
</script>

<style scoped>
.container {
  margin-top: 16px;
  padding: 25px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #ffffff;
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #111111;
}

.caption-and-select-container {
  text-align: left;
  margin-right: 24px;
}

.caption {
  margin-right: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.select {
  width: 120px;
}

.stat-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

.stat-card {
  flex: 1;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  min-height: 120px;
  background: #ffffff;
  position: relative;
}

.rank-card {
  flex: 1;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  padding: 14px;
  background: #f8fafc;
  box-shadow: inset 0 0 0 1px rgba(203, 213, 225, 0.45);
  position: relative;
}

.stat-card-icon {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 24px;
  width: 28px;
  height: 28px;
  justify-content: center;
}

.rank-card-title,
.stat-card-icon {
  display: flex;
  align-items: center;
}

.rank-card-title {
  gap: 10px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.rank-card-icon,
.stat-card-icon {
  font-size: 24px;
  width: 28px;
  height: 28px;
  justify-content: center;
}

.stat-card-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px 10px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 700;
}

.stat-card-title {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
}

.stat-card-value {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
}

.stat-card-unit {
  font-size: 16px;
  font-weight: 600;
  margin-left: 4px;
}

.stat-card-sub {
  margin-top: 10px;
  color: #6b7280;
  font-size: 12.5px;
  line-height: 1.4;
  margin: 10px 10px 0 10px;
}

.stat-rate-up {
  color: #00C950;
  font-weight: 700;
}

.stat-rate-down {
  color: #FB2C36;
  font-weight: 700;
}

.rank-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
}

.rank {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
}

.ranker {
  flex: 1;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: left;
}

.ranker-main {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  line-height: 1.4;
}

.ranker-sub {
  font-size: 12px;
  color: #6b7280;
}

.ranker-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.ranker-stats-main {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.ranker-stats-sub {
  font-size: 12px;
  color: #6b7280;
}
</style>
